import { createContext, Dispatch, SetStateAction } from 'react';

export const ProfileMenuContext = createContext<{
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>> | null;
}>({ isOpen: false, setIsOpen: null });
